module.exports = __webpack_public_path__ + "img/instructor4.502aa60b.png";